import routes from '../../app/global/routes'
import { lazyWithRetry } from '../../utils'
import { AppRouteProps } from '../types'

const SearchResultsPage = lazyWithRetry(
  () => import('app/global/pages/SearchResultsPage')
)

const DeprecatedFeaturePage = lazyWithRetry(
  () => import('app/global/pages/DeprecatedFeaturePage')
)

const BookAuraPage = lazyWithRetry(
  () => import('app/global/pages/BookAuraPage')
)

export const globalRoutes: AppRouteProps[] = [
  {
    path: routes.searchResults,
    element: <SearchResultsPage />,
    footer: { hidden: true },
  },
  {
    path: routes.unavailable,
    element: <DeprecatedFeaturePage />,
    footer: { hidden: true },
    header: { hidden: true },
  },
  {
    path: routes.bookAura,
    element: <BookAuraPage />,
    head: { title: 'Book Aura' },
    footer: { hidden: true },
    header: { hidden: true },
  },
]
